export function getStorageItem(key: string) {
  return localStorage.getItem(key);
}

export function setStorageItem<T = unknown>(key: string, value: T | undefined, stringify = true) {
  localStorage.setItem(key, stringify ? JSON.stringify(value) : value as string);
}

export function removeStorageItem(key: string) {
  localStorage.removeItem(key);
}
